import SearchIcon from '@mui/icons-material/Search';
import {
  Avatar,
  Box,
  Button,
  InputAdornment,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  TextField,
} from '@mui/material';
import { useMemo, useState } from 'react';

const normalizeText = (value = '') =>
  value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

const TicketDetailsPopover = ({
  open,
  handleClose,
  positionX,
  positionY,
  dataUsersList,
  handleChangeUser,
}) => {
  const [agentSearch, setAgentSearch] = useState('');

  const filteredUsers = useMemo(() => {
    const users = dataUsersList || [];
    const searchValue = normalizeText(agentSearch);

    if (!searchValue) return users;

    const searchTerms = searchValue.split(/\s+/).filter(Boolean);

    return users.filter((elem) => {
      const fullName = normalizeText(
        `${elem?.name || ''} ${elem?.last_name || ''} ${
          elem?.mother_last_name || elem?.mothers_last_name || ''
        }`,
      );

      return searchTerms.every((term) => fullName.includes(term));
    });
  }, [agentSearch, dataUsersList]);

  return (
    <Popover
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
      anchorReference='anchorPosition'
      anchorPosition={{
        top: positionY,
        left: positionX,
      }}
    >
      <Box sx={{ width: 320, maxWidth: '100%' }}>
        <Box
          sx={{
            backgroundColor: '#e5e5e5',
            px: 2,
            py: 1.5,
          }}
        >
          <h3 style={{ margin: 0, textAlign: 'left' }}>Reasignar ejecutivo</h3>
        </Box>

        <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid #f0f0f0' }}>
          <TextField
            fullWidth
            size='small'
            placeholder='Nombre del agente'
            value={agentSearch}
            onChange={(event) => setAgentSearch(event.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <SearchIcon fontSize='small' />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <List
          sx={{
            width: '100%',
            maxWidth: 500,
            bgcolor: 'background.paper',
            position: 'relative',
            overflow: 'auto',
            maxHeight: 260,
            '& ul': { padding: 10 },
            py: 0.5,
          }}
        >
          {filteredUsers?.map((elem, index) => {
            return (
              <ListItem key={index} disablePadding>
                <Button
                  fullWidth
                  sx={{
                    justifyContent: 'flex-start',
                    textTransform: 'none',
                    px: 1.5,
                    py: 1,
                    borderRadius: 0,
                    color: '#000000',
                    '&:hover .MuiListItemText-primary': {
                      color: '#ffffff',
                    },
                  }}
                  onClick={() =>
                    handleChangeUser({
                      id: elem.id,
                    })
                  }
                >
                  <ListItemAvatar>
                    <Avatar className={'avatar'} sx={{ width: 35, height: 35, fontSize: 12 }}>
                      {elem?.name[0]}
                      {elem?.last_name[0]}
                      {elem?.mother_last_name === undefined ? '' : elem?.mother_last_name[0]}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    sx={{
                      textAlign: 'left',
                      my: 0,
                      '& .MuiListItemText-primary': {
                        textAlign: 'left',
                        lineHeight: 1.2,
                        color: '#000000',
                      },
                      '& .MuiListItemText-secondary': {
                        textAlign: 'left',
                        fontSize: 12,
                        color: '#6b7280',
                      },
                    }}
                    primary={`${elem?.name} ${elem?.last_name} ${elem?.mother_last_name ?? ''}`}
                    secondary={elem?.email}
                  />
                </Button>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Popover>
  );
};

export default TicketDetailsPopover;
